module.exports = __webpack_public_path__ + "static/media/benefits-360_wheel.b2ac9075.png";